export const CommunityModerationActionType = {
  MEMBER_BANNED: 'member_banned',
  MEMBER_REMOVED: 'member_removed',
  MODERATOR_ASSIGNED: 'moderator_assigned',
  MODERATOR_REMOVED: 'moderator_removed',
  MODERATOR_ROLE_CREATED: 'moderator_role_created',
  MODERATOR_ROLE_UPDATED: 'moderator_role_updated',
  MODERATOR_ROLE_DELETED: 'moderator_role_deleted',
  MODERATOR_ROLE_ASSIGNED: 'moderator_role_assigned',
  POST_REMOVED: 'post_removed',
  POST_PINNED: 'post_pinned',
  POST_SPAM_CLEARED: 'post_spam_cleared',
  POST_SPAM_ACTIONED: 'post_spam_actioned',
  REPORT_RESOLVED: 'report_resolved',
  REPORT_DISMISSED: 'report_dismissed',
  REPORT_ESCALATED: 'report_escalated',
  SPAM_BLOCKED: 'spam_blocked',
  SPAM_SETTINGS_UPDATED: 'spam_settings_updated',
  GUIDELINES_ACCEPTED: 'guidelines_accepted',
  APPEAL_SUBMITTED: 'appeal_submitted',
  APPEAL_APPROVED: 'appeal_approved',
  APPEAL_DENIED: 'appeal_denied',
  OWNERSHIP_TRANSFER_INITIATED: 'ownership_transfer_initiated',
  OWNERSHIP_TRANSFER_ACCEPTED: 'ownership_transfer_accepted',
  OWNERSHIP_TRANSFER_CANCELLED: 'ownership_transfer_cancelled',
} as const;

export type CommunityModerationActionTypeValue =
  (typeof CommunityModerationActionType)[keyof typeof CommunityModerationActionType];
